module.exports = __webpack_public_path__ + "static/media/google_pay_icon.05fd8dc7.webp";